/**
 * NotificationBell - Bell icon with badge for header
 * 
 * Shows unread count and opens dropdown/panel
 */

import React, { useState, useEffect, useRef } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationDropdown from './NotificationDropdown';
import '../styles/Notifications.css';

const BellIcon = () => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const NotificationBell = () => {
  const { unreadCount, isConnected } = useNotifications();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [shouldShake, setShouldShake] = useState(false);
  const prevUnreadCountRef = useRef(unreadCount);
  const containerRef = useRef(null);

  // Shake animation when new notification arrives
  useEffect(() => {
    if (unreadCount > prevUnreadCountRef.current) {
      setShouldShake(true);
      const timer = setTimeout(() => setShouldShake(false), 500);
      return () => clearTimeout(timer);
    }
    prevUnreadCountRef.current = unreadCount;
  }, [unreadCount]);

  const handleClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  // Format badge count
  const getBadgeContent = () => {
    if (unreadCount <= 0) return null;
    if (unreadCount > 99) return '99+';
    return unreadCount;
  };

  const badgeContent = getBadgeContent();

  return (
    <div className="notification-bell-container" ref={containerRef}>
      <button
        className={`notification-bell ${shouldShake ? 'notification-bell--shake' : ''}`}
        onClick={handleClick}
        aria-label={`Уведомления${unreadCount > 0 ? `, ${unreadCount} непрочитанных` : ''}`}
        aria-expanded={isDropdownOpen}
        aria-haspopup="true"
      >
        <BellIcon />
        
        {badgeContent && (
          <span 
            className={`notification-bell__badge ${unreadCount > 9 ? 'notification-bell__badge--large' : ''}`}
          >
            {badgeContent}
          </span>
        )}
        
        {/* Connection indicator (optional, for debugging) */}
        {/* {isConnected && (
          <span 
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: '#4caf50',
              border: '2px solid white',
            }}
          />
        )} */}
      </button>

      <NotificationDropdown 
        isOpen={isDropdownOpen} 
        onClose={handleClose}
      />
    </div>
  );
};

export default NotificationBell;

